<template>
  <b-modal id="bv-modal-show-qr-picacode" size="sm" hide-header centered>
    <div class="text-center">
       <h1 class="modal-title mb-2">{{ $t('modal_show_qr_picacode.title') }}</h1>
      <h4 class="modal-subtitle mb-2"><span class="code">{{picacode}}</span></h4>
      <div class="d-inline-block px-2 pt-2" style="background-color: white">
         <qr-code-generator :size="250" :value="picacode"></qr-code-generator>
      </div>
    </div>
     <template #modal-footer="{ ok, cancel }">
      <div class="row w-100 justify-content-center">
        <div class="col-sm-6 order-sm-0">
          <b-button variant="light" block @click="cancel()">
            {{ $t('modal_show_qr_picacode.action_cancel') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>

import QrCodeGenerator from "@/components/QrCodeGenerator.vue";

export default {
  props: ['picacode'],
  components: {
    QrCodeGenerator,
  },
  computed: {
    checkinDetailUrl() {
      return this.$router.resolve({
        name: 'checkins-detail',
        params: {picacode: this.picacode},
      }).href;
    },
    checkinDetailAbsoluteUrl() {
      return `${location.origin}${this.checkinDetailUrl}`
    }
  },
  methods: {
     cancel() {
      this.$bvModal.hide('bv-modal-show-qr-picacode')
    }
  }
}
</script>
